import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalrequestabandoned-card',
  templateUrl: './helpbutton-reports-totalrequestabandoned-card.component.html',
  styleUrls: ['./helpbutton-reports-totalrequestabandoned-card.component.scss']
})
export class HelpbuttonReportsTotalrequestabandonedCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
